import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import React, { useState } from 'react';
import { STARTER_API } from '../ApiNames';
import { LoginService } from '../services/LoginService';
import { Link } from 'react-router-dom';

var imageName = require('./../assets/img/mdcal.png');


export const ForgetPassword = () => {
    const [username, setusername] = useState('');
    const handleLogin = async () => {
        try {
            const payload = { username: username };
            const apiname = STARTER_API.FORGETPASS_API;
            const data = await LoginService.getData(apiname, payload);
        } catch (error) {

        }
    };

    return (
        <div className="main-body flex justify-content-center align-items-center" style={{ flexDirection: 'column', minHeight: '100vh' }}>
            {/* Logo Section */}
            <div className="logo-container mb-4" style={{ display: 'flex', justifyContent: 'center', minWidth: '220px' }}>
                <img src={imageName} alt="Logo" width="220px" style={{ width: '450px' }} />
            </div>

            {/* Login Box */}
            <div className="surface-card p-4 shadow-2 border-round w-full lg:w-4">
                <div className="text-center mb-5">
                    <div className="text-900 text-3x font-medium mb-3">
                        <h2 style={{ color: 'rgb(102, 102, 102)', fontSize: '20px', fontWeight: '400' }}>
                            You forgot your password? Here you can easily retrieve a new password.
                        </h2>
                    </div>
                </div>
                <div>
                    <div className="grid" style={{ position: 'relative' }}>
                        <div style={{ position: 'relative', width: '100%' }}>
                            <InputText id="email" type="text" placeholder="Enter Email" className="w-full mb-1 pr-5" value={username} onChange={(e) => setusername(e.target.value)} />
                        </div>
                    </div>
                    <Button
                        label="Request new password"
                        style={{ backgroundColor: '#007bff', marginTop: '20px', color:'#fff' }}
                        onClick={handleLogin} text raised
                    />
                    <br />
                    <Link
                        to="/"
                        style={{ float: 'left', color: '#007bff', fontSize: '20px', marginTop: '20px',textDecoration:'none' }}
                        className="p-button-sm"
                    >
                        Login
                    </Link>  
                    </div>

            </div>
        </div>
    )
}
